import { render, staticRenderFns } from "./ListaPedidos.vue?vue&type=template&id=34e4b3a9&scoped=true"
import script from "./ListaPedidos.vue?vue&type=script&lang=js"
export * from "./ListaPedidos.vue?vue&type=script&lang=js"
import style0 from "./ListaPedidos.vue?vue&type=style&index=0&id=34e4b3a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e4b3a9",
  null
  
)

export default component.exports